import { Component, Input } from '@angular/core'

import { DEFAULT_COLOR } from '../constants';

@Component({
    selector: 'atx-nav-bar',
    template: `<nav class="navbar navbar-{{ color }} bg-{{ color }}">
    <div class="justify-content-{{ justify }}"
         [class.container]="hasContainer">
        <ng-content></ng-content>
    </div>
</nav>
`,
    styles: [``],
})

export class AtxNavBarComponent {
    @Input() public readonly justify: string;
    @Input() public readonly hasContainer: boolean;
    @Input() public readonly color: string = DEFAULT_COLOR;
}
